export function findTypeByCode(code, types) {
    if (!types) {
        return null
    }

    for (const type of types) {
        if (type.code === code) {
            return type
        } else {
            const typeFound = findTypeByCode(code, type.children)
            if (typeFound) {
                return typeFound
            }
        }
    }

    return null
}